// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"211":"4436fce7","283":"e6895216","316":"bb2a5a3c","363":"fef7e9ea","364":"9d40b10d","410":"28dde8e0","412":"40884b3d","570":"0c238d49","607":"9b28b212","713":"2d07d6e2","717":"bff4cccf","959":"4530fd8d","991":"46084433"}[chunkId] + ".chunk.js";
};